import script from "./CatalogMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./CatalogMenu.vue?vue&type=script&setup=true&lang=ts"

import "./CatalogMenu.vue?vue&type=style&index=0&id=4a283c8c&lang=scss"

const __exports__ = script;

export default __exports__